import { enhancedMakeFetchAction } from '@stagapps/redux-utils'
import { API_BASE_URL, API_VERSION } from 'config/env.config'

export const POST_USER_UPDATE_PASSWORD = 'EMPLOYEE/POST_USER_UPDATE_PASSWORD'

const apiCall = enhancedMakeFetchAction(
  POST_USER_UPDATE_PASSWORD,
  ({ password, password_confirmation, current_password }) => ({
    endpoint: `${API_BASE_URL}/investcore-api/app/${API_VERSION}/users/password`,

    method: 'PATCH',
    body: {
      password,
      password_confirmation,
      current_password
    }
  })
)

export default apiCall
